import { useEffect, useRef } from 'react';
import { ptiaVersementEnum } from '@@viewEnums';
import { propEq } from 'ramda';
import extraMadelin from '../extra/extraMadelin.js';

const useRules = ({ form }) => {
  const firstRenderTTCause = useRef(true);
  const firstRenderAcc = useRef(true);
  const firstRenderMad = useRef(true);

  const ptiaTTCause = form.watch('guarantees.OPTION_TT_CAUSE.selected');
  const ptiaAcc = form.watch('guarantees.OPTION_ACC.selected');
  const optionTtCause = form.watch('guarantees.OPTION_TT_CAUSE.selected');
  const optionAcc = form.watch('guarantees.OPTION_ACC.selected');
  const ptiaVersement = form.watch('guarantees.TT_CAUSE_DEP.value');
  const accVersement = form.watch('guarantees.ACC_DEP.value');

  useEffect(() => {
    if (propEq('current', true, firstRenderTTCause)) {
      firstRenderTTCause.current = false;
      return;
    }
    if (ptiaTTCause) {
      form.setValue('guarantees.OPTION_ACC.selected', false);
    }
  }, [ptiaTTCause]);

  useEffect(() => {
    if (propEq('current', true, firstRenderAcc)) {
      firstRenderAcc.current = false;
      return;
    }
    if (ptiaAcc) {
      form.setValue('guarantees.OPTION_TT_CAUSE.selected', false);
    }
  }, [ptiaAcc]);

  useEffect(() => {
    if (
      optionTtCause &&
      ptiaVersement === ptiaVersementEnum.CAPITAL &&
      form.watch('guarantees.TT_CAUSE_MAD')
    ) {
      form.setValue('guarantees.TT_CAUSE_MAD.editable', false);
      form.setValue('guarantees.TT_CAUSE_MAD.selected', false);
    }
    if (
      optionAcc &&
      accVersement === ptiaVersementEnum.CAPITAL &&
      form.watch('guarantees.ACC_MAD')
    ) {
      form.setValue('guarantees.ACC_MAD.editable', false);
      form.setValue('guarantees.ACC_MAD.selected', false);
    }
    if (propEq('current', true, firstRenderMad)) {
      firstRenderMad.current = false;
      return;
    }
    if (
      optionTtCause &&
      ptiaVersement === ptiaVersementEnum.RENTE &&
      form.watch('guarantees.TT_CAUSE_MAD')
    ) {
      form.setValue('guarantees.TT_CAUSE_MAD.editable', true);
      form.setValue('guarantees.TT_CAUSE_MAD.selected', true);
      extraMadelin(true, form);
    }
    if (optionAcc && accVersement === ptiaVersementEnum.RENTE && form.watch('guarantees.ACC_MAD')) {
      form.setValue('guarantees.ACC_MAD.editable', true);
      form.setValue('guarantees.ACC_MAD.selected', true);
      extraMadelin(true, form);
    }
  }, [ptiaVersement, accVersement]);

  return {};
};

export default useRules;
